export default __webpack_public_path__ + "static/media/@cami.smaniotto.fc35d6e0.jpg";